/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PotentialChangeOrdersControllerFindAllQueryResponse, PotentialChangeOrdersControllerFindAllQueryParams, PotentialChangeOrdersControllerFindAll401, PotentialChangeOrdersControllerFindAll403 } from "../../models/changeOrdersController/PotentialChangeOrdersControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { potentialChangeOrdersControllerFindAll } from "../../clients/change-ordersService/potentialChangeOrdersControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const potentialChangeOrdersControllerFindAllQueryKey = (params: PotentialChangeOrdersControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/potential-change-orders'
}, ...(params ? [params] : [])] as const;
export type PotentialChangeOrdersControllerFindAllQueryKey = ReturnType<typeof potentialChangeOrdersControllerFindAllQueryKey>;
export function potentialChangeOrdersControllerFindAllQueryOptions(params?: PotentialChangeOrdersControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = potentialChangeOrdersControllerFindAllQueryKey(params);
  return queryOptions<PotentialChangeOrdersControllerFindAllQueryResponse, ResponseErrorConfig<PotentialChangeOrdersControllerFindAll401 | PotentialChangeOrdersControllerFindAll403>, PotentialChangeOrdersControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return potentialChangeOrdersControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List potential change orders (scope-filtered)
 * {@link /api/v1/potential-change-orders}
 */
export function usePotentialChangeOrdersControllerFindAll<TData = PotentialChangeOrdersControllerFindAllQueryResponse, TQueryData = PotentialChangeOrdersControllerFindAllQueryResponse, TQueryKey extends QueryKey = PotentialChangeOrdersControllerFindAllQueryKey>(params?: PotentialChangeOrdersControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<PotentialChangeOrdersControllerFindAllQueryResponse, ResponseErrorConfig<PotentialChangeOrdersControllerFindAll401 | PotentialChangeOrdersControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? potentialChangeOrdersControllerFindAllQueryKey(params);
  const query = useQuery({
    ...potentialChangeOrdersControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PotentialChangeOrdersControllerFindAll401 | PotentialChangeOrdersControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}